import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';
import * as myAccountActions from '../../../my-account/redux/actions';
import * as serviceActions from '../../../pb-service-list/redux/actions';

import { KuposDatePicker, KuposErrorSuccessModal, KuposInput, KuposSelectBox } from '../../../common';
import React, { useRef, useState } from 'react';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import ThemeTenTitle from '../components/ThemeTenTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { useTranslation } from 'react-i18next';
import { AppData } from '../../../../services';
import DateService from '../../../../services/dateService';

const ThemeTenServiciosEspeciales = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;
  const initialState = {
    name: '',
    nameError: '',
    lastNameError: '',
    lastName: '',
    email: '',
    emailError: '',
    origin: '',
    originError: '',
    destination: '',
    destinationError: '',
    date: '',
    dateError: '',
    noOfPassengers: '',
    noOfPassengersError: '',
    comments: '',
    commentsError: '',
				showModal: false
  };
  const [state, setState] = useState(initialState);
  const { t } = useTranslation('common');
  const errorInitialState = {
    source: '',
    destination: '',
    date: '',
  };

  const destinationRef = useRef({});
  const [error, setError] = useState(errorInitialState);

  const onSourceChange = value => {
    setError({ ...error, source: null });
    props.actions.pbSetSourceCity(value);
    getOriginSelectedFilteredDestinations(props.home.uniqueCities, props.home.pbSourceCity);

    if (props.home.pbDestinationCity && value.value === props.home.pbDestinationCity.value) {
      onDestinationChange(null);
    }

    // destinationRef.current.onMenuOpen();
    // destinationRef.current.select.focus();
  };

  const onDestinationChange = value => {
    setError({ ...error, destination: null });
    props.actions.pbSetDestinationCity(value);
  };

  const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
    if (rawArray && itemToRemove) {
      return rawArray
        .map(function(obj) {
          if (obj.label == itemToRemove.label) {
          } else {
            return obj;
          }
        })
        .filter(function(obj) {
          return typeof obj !== 'undefined';
        });
    } else if (!itemToRemove) {
      // return rawArray;
    }
  };

  const onInputChange = (value, field) => {
    setState({
      ...state,
      [field]: value,
      [`${field}Error`]: '',
    });
  };

  const isFormValid = () => {
    let error = 0;
    if (!state.name) {
      setState(prevData => ({
        ...prevData,
        nameError: 'Ingresa tu nombre y apellido',
      }));
      error++;
    }
    if (!state.lastName) {
      setState(prevData => ({
        ...prevData,
        lastNameError: 'Selecciona tu Tipo de solicitud',
      }));
      error++;
    }

    if (!state.date) {
      setState(prevData => ({
        ...prevData,
        dateError: 'Ingresa tu apellido',
      }));
      error++;
    }

    if (!state.email) {
      setState(prevData => ({
        ...prevData,
        emailError: 'Ingresa tu correo electrónico',
      }));
      error++;
    } else if (!CommonService.isEMailValid(state.email)) {
      setState(prevData => ({
        ...prevData,
        emailError: 'Ingresa tu correo electrónico',
      }));
      error++;
    }

    if (!state.noOfPassengers) {
      setState(prevData => ({
        ...prevData,
        noOfPassengersError: 'Ingresa el n° de pasajeros',
      }));
      error++;
    }

    if (!state.comments) {
      setState(prevData => ({
        ...prevData,
        commentsError: 'Ingresa los detalles de tu solicitud',
      }));
      error++;
    }

    if (!state.date) {
      setState(prevData => ({
        ...prevData,
        dateError: 'Ingresa tu fecha de viaje',
      }));
      error++;
    }

    return error;
  };

  const update = () => {
    if (!isFormValid()) {
      return;
    }

    // if (!props.home.pbSourceCity) {
    //   setError({ ...error, source: 'VALIDATIONS.VALID_ORIGIN_CITY_TRAVELTUR' });
    //   return;
    // } else if (!props.home.pbDestinationCity) {
    //   setError({ ...error, destination: 'VALIDATIONS.VALID_ORIGIN_CITY_TRAVELTUR_DESTINATION' });
    if (!props.home.pbSourceCity || !props.home.pbDestinationCity) {
      setError({
        ...error,
        destination: !props.home.pbDestinationCity ? 'VALIDATIONS.VALID_ORIGIN_CITY_TRAVELTUR_DESTINATION': "",
        source: !props.home.pbSourceCity ?'VALIDATIONS.VALID_ORIGIN_CITY_TRAVELTUR': "",
      });
      return;
    }

    let source = props.home.pbSourceCity && props.home.pbSourceCity.label;
    let dest = props.home.pbDestinationCity && props.home.pbDestinationCity.label;

    let data = {
      first_name: state.name,
      last_name: state.lastName,
      rut_number: '',
      phone_number: '',
      email: state.email,
      origin: source,
      destination: dest,
      travel_date: state.date,
      no_of_passengers: state.noOfPassengers,
      comments: state.comments,
						api_operator_id: operator.operator_id
    };

    props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/special_service_request',
        method: 'POST',
        data: {
          special_service_request: data,
        },
      })
      .then(
        res => onContactInfoResponse(res),
        err => onContactInfoResponse(err),
      );
  };

  const onContactInfoResponse = res => {
   
    if (res && res.data && res.data && res.data.message) {
      setState({
        ...state,
        showModal: true,
        responseMessage: res.data.message,
        status: res.data.status,
      });
    }
  };
		
  return (
    <div>
      <style>
  {`
    .common-kupos-input .input-outer div {
      flex: 1;
    }
    .common-kupos-pleaces-input::placeholder {
      padding-left: 0px;
    }
    .common-kupos-pleaces-input {
      padding-left: 0px;
    }
  `}
</style>

      <KuposHelmet />
      <HeroSection
        heroImage={getIcons('ServiceBanner', operator)}
        height={'41vh'}
        title={'Servicios Especiales'}
        description={'Home / Servicios Especiales'}
        marginTop="-50px"
      />
      <div className="new-container">
        <div style={{ marginTop: 40 }}>
          <ThemeTenTitle title={'COTIZA TU SERVICIO ESPECIAL'} />
        </div>
        <div className="font11 montserrat text-center lh-1-3 px-3">
          <p>
            En Traveltur ponemos a tu disposición nuestro servicio de viajes especiales, que te
            permite acceder a traslados exclusivos para tu empresa, organización o viaje grupal.
            Este servicio es ideal para grupos de al menos 7 pasajeros, garantizándoles un servicio
            excepcional y personalizado, en buses de última generación y con los más altos
            estándares de seguridad.
          </p>
        </div>
        <div className="contact-form-head text-uppercase service-form-themeten favorite-destinations-heading align-center  montserrat-bold font12 w-50">
          <div className="px-5 text-uppercase m-0 bold-text form-name">
            {'SERVICIO ESPECIALES'}
            <span class="d-inline-block title-dash-line"></span>
          </div>

          <div className=" py-4 contact-form  montserrat-bold service-form-theme">
            <div className="d-flex px-4">
              <div className="form-group   pl-2 montserrat  w-50">
                <div>
                  <label className="w-100" htmlFor="">
                    Nombre Y Apellido
                  </label>
                  <KuposInput
                    type="text"
                    value={state.name}
                    onChange={newValue => onInputChange(newValue, 'name')}
                    // onBlur={text => onInputBlur(text, 'name')}
                    placeholder={'Nombre Y Apellido'}
                    error={!!state.nameError}
                    errorMessage={state.nameError}
                    className="kupos-border"
                  />
                </div>
              </div>

              <div className="form-group   pl-2 montserrat  w-50">
                <div>
                  <label className="w-100" htmlFor="">
                    Correo electrónico
                  </label>
                  <KuposInput
                    type="text"
                    value={state.email}
                    onChange={newValue => onInputChange(newValue, 'email')}
                    // onBlur={text => onInputBlur(text, 'email')}
                    placeholder={'Correo electrónico'}
                    error={state.emailError}
                    errorMessage={state.emailError}
                    className="kupos-border"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex px-4">
              <div className="   pl-2 montserrat  w-50">
                <div>
                  <label className="w-100" htmlFor="">
                    Origen
                  </label>
                  <KuposInput
                    type="places"
                    reactSelect
                    selectType="origin"
                    placeholder={t('HOME.ORIGIN')}
                    options={props.home.uniqueCities}
                    selectedOption={props.home.pbSourceCity}
                    onChange={onSourceChange}
                    icon={getIcons('OriginoIcon', operator)}
                    t={t}
                    error={error.source ? true : false}
                    errorMessage={t(error.source)}
                    className="w-100 montserrat font9 placeholder-padding-right"
                    height={40}
                    inputWidth={{paddingLeft:"30px"}}
                  />
                </div>
              </div>

              <div className="form-group   pl-2 montserrat  w-50">
                <div>
                  <label className="w-100" htmlFor="">
                    Destino
                  </label>

                  <KuposInput
                    type="places"
                    reactSelect
                    selectType="destination"
                    icon={getIcons('DestinationoIcon', operator)}
                    t={t}
                    selectRef={destinationRef}
                    options={
                      props.home.pbSourceCity
                        ? getOriginSelectedFilteredDestinations(
                            props.home.uniqueCities,
                            props.home.pbSourceCity,
                          )
                        : []
                    }
                    selectedOption={props.home.pbDestinationCity}
                    onChange={onDestinationChange}
                    className="w-100 montserrat font9 placeholder-padding-right"
                    hideArrow={true}
                    placeholder={'Destino'}
                    error={error.destination ? true : false}
                    errorMessage={t(error.destination)}
                    height={40}
                    inputWidth={{paddingLeft:"30px"}}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex px-4">
              <div className="form-group   pl-2 montserrat  w-50">
                <div>
                  <label className="w-100" htmlFor="">
                  FECHA de viaje
                  </label>
                </div>
                <KuposDatePicker
                  minDate={DateService.getTodayString()}
                  // canChangeYear={true}
                  // placeholder={DateService.getTodayString()}
                  icon={getIcons('DateIcon', operator)}
                  img='<img src="/assets/traveltur/services/datum.svg" />'
                  selectedDate={state.date}
                  onDateChange={newValue => onInputChange(newValue, 'date')}
                  error={!!state.dateError}
                  errorMessage={state.dateError}
                  t={t}
                />
              </div>

              <div className="form-group   pl-2 montserrat  w-50">
                <div>
                  <label className="w-100" htmlFor="">
                  N° de pasajeros
                  </label>
                  <KuposInput
                    type="text"
                    value={state.noOfPassengers}
                    onChange={newValue => onInputChange(newValue, 'noOfPassengers')}
                    placeholder="N° de pasajeros"
                    // onBlur={text => onInputBlur(text, 'noOfPassengers')}
                    error={!!state.noOfPassengersError}
                    errorMessage={state.noOfPassengersError}
                    className="kupos-border"
                  />
                </div>
              </div>
            </div>
            <div className="pl-2">
              <div className="form-group w-100 px-4 montserrat">
                <label className="w-100 " htmlFor="">
                Comentarios / Observaciones
                </label>
                <textarea
                  type="text"
                  className="w-100 montserrat font9 textarea-placeholder-gray"
                  rows="3"
                  placeholder="Comentarios / Observaciones"
                  value={state.comments}
                  onChange={e => onInputChange(e.target.value, 'comments')}
                />
                {state.commentsError && (
                  <span className="error font8" style={{ color: 'red' }}>
                    {state.commentsError}
                  </span>
                )}
              </div>
            </div>
            <div className="form-group px-4 m-0 text-center">
              <button
                className="less-bold-text"
                style={{
                  background: operator && operator.color_codes && operator.color_codes.button_color,
                }}
                onClick={update}
              >
                ENVIAR SOLICITUD
              </button>
            </div>
          </div>
          <KuposErrorSuccessModal
            success={true}
            showModal={state.showModal}
            onButtonClick={() => {
              setState({ showModal: false });
              window.location.reload();
            }}
            bodyText={state.responseMessage}
          />
        </div>
      </div>
    </div>
  );
};
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...actions,
        ...serviceActions,
        ...myAccountActions,
        ...commonActions,
        ...homeActions,
      },
      dispatch,
    ),
  };
}

// /* istanbul ignore next */
// function mapDispatchToProps(dispatch) {
//   return {
//     actions: bindActionCreators({ ...actions }, dispatch),
//   };
// }
export default connect(mapStateToProps, mapDispatchToProps)(ThemeTenServiciosEspeciales);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/ThemeTenPages/ThemeTenServiciosEspeciales.js